// extracted by mini-css-extract-plugin
export default {"wrapper":"UB","subscription":"VB","select_item":"WB","is_selected":"XB","otb":"YB","radio":"ZB","first_row":"aC","prices":"bC","italic":"cC","info_wrapper":"eC","first_month":"fC","separator":"gC","checkmark":"hC","bullets":"iC","bullet":"jC","checkmarkText":"kC","button":"lC","discountBadge":"mC"};
    if(module.hot) {
      // 1714422956159
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  